<template>
    <!-- Visionneuse des photos d'une liste de documents : agrandissement, zoom au clic, navigation entre les photos -->
    <b-modal :id="modalId" size="xl" centered hide-footer body-class="ix-image-viewer-body" header-class="ix-image-viewer-header" @hidden="zoomed = false">
        <template #modal-title>
            <span class="ix-image-viewer-title" v-if="current">{{ current.name }}.{{ current.extension }}</span>
            <span class="ix-image-viewer-counter" v-if="images.length > 1">{{ index + 1 }} / {{ images.length }}</span>
        </template>

        <div class="ix-image-viewer" v-if="current" @keydown.left.prevent="previous" @keydown.right.prevent="next" tabindex="0" ref="viewer">
            <button type="button" class="ix-image-viewer-nav previous" v-if="images.length > 1" @click="previous" title="Photo précédente (←)">
                <i class="far fa-chevron-left"></i>
            </button>

            <div class="ix-image-viewer-stage" :class="{'is-zoomed': zoomed}">
                <img :src="current.document_path" :alt="current.name" :class="{'is-zoomed': zoomed}" @click="zoomed = !zoomed" :title="zoomed ? 'Cliquer pour ajuster à l\'écran' : 'Cliquer pour afficher en taille réelle'">
            </div>

            <button type="button" class="ix-image-viewer-nav next" v-if="images.length > 1" @click="next" title="Photo suivante (→)">
                <i class="far fa-chevron-right"></i>
            </button>
        </div>

        <div class="ix-image-viewer-actions" v-if="current">
            <a :href="current.document_path" target="_blank" class="ix-btn transparent"><i class="far fa-external-link"></i> Ouvrir dans un nouvel onglet</a>
        </div>
    </b-modal>
</template>

<script>
import { isDocumentImage } from './documentImage';

export default {
    name: 'document-image-viewer',
    data() {
        return {
            modalId: 'document-image-viewer-' + Math.random().toString(36).substr(2, 9),
            images: [],
            index: 0,
            zoomed: false,
        };
    },
    computed: {
        current() {
            return this.images[this.index] || null;
        },
    },
    methods: {
        isImage(document) {
            return isDocumentImage(document);
        },
        // Ouvre la photo choisie parmi celles de la liste
        open(document, documents) {
            this.images = (documents || [document]).filter(item => this.isImage(item));
            this.index = Math.max(0, this.images.findIndex(item => item === document || (item.id && item.id === document.id)));
            this.zoomed = false;
            this.$bvModal.show(this.modalId);
            this.$nextTick(() => this.$refs.viewer && this.$refs.viewer.focus());
        },
        previous() {
            this.zoomed = false;
            this.index = (this.index - 1 + this.images.length) % this.images.length;
        },
        next() {
            this.zoomed = false;
            this.index = (this.index + 1) % this.images.length;
        },
    },
};
</script>

<style>
    .ix-image-viewer-header .modal-title {
        display: flex;
        align-items: center;
        gap: 10px;
        min-width: 0;
    }

    .ix-image-viewer-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .ix-image-viewer-counter {
        flex-shrink: 0;
        font-size: 12px;
        font-weight: normal;
        color: var(--ix-text-secondary);
    }

    .ix-image-viewer-body {
        padding: 0;
    }

    .ix-image-viewer {
        position: relative;
        background: #1f2328;
        outline: none;
    }

    .ix-image-viewer-stage {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 75vh;
        overflow: hidden;
    }

    .ix-image-viewer-stage.is-zoomed {
        display: block;
        overflow: auto;
    }

    .ix-image-viewer-stage img {
        max-width: 100%;
        max-height: 100%;
        object-fit: contain;
        cursor: zoom-in;
    }

    .ix-image-viewer-stage img.is-zoomed {
        max-width: none;
        max-height: none;
        cursor: zoom-out;
    }

    .ix-image-viewer-nav {
        position: absolute;
        top: 50%;
        z-index: 2;
        width: 42px;
        height: 42px;
        margin-top: -21px;
        border: none;
        border-radius: 50%;
        background: rgba(255, 255, 255, .85);
        color: #1f2328;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .3);
        cursor: pointer;
    }

    .ix-image-viewer-nav:hover {
        background: #fff;
    }

    .ix-image-viewer-nav.previous {
        left: 12px;
    }

    .ix-image-viewer-nav.next {
        right: 12px;
    }

    .ix-image-viewer-actions {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        padding: 10px 16px;
    }
</style>
